import type { WebsiteConfig } from "@/types/WebsiteConfig";

/**
 * Does the event HAVE a website — not merely a website_config ROW?
 *
 * A row alone is a SHELL: `setupCustomWebsite` creates one when none exists,
 * deleting the custom upload only resets the custom-* flags, and since
 * 2026-09-28 the empty state's settings gear mints one (`POST /ensure`) so the
 * settings dialog can open before a template is chosen. A shell has no pages
 * and no uploaded custom site; every create path may take it over (the
 * backend's `createWebsiteConfig` adopts it — `isEmptyWebsiteShell`).
 *
 * The one predicate the configurator's duplicate-create guard, the website
 * landing page's empty state and Velo's `generate_website_from_blocks`
 * (`persistWebsiteDraft`) share. `pages`/`metaPage` are what
 * `initializeOverview` returns.
 */
export function hasWebsiteContent(
  pages: readonly unknown[],
  metaPage: Pick<WebsiteConfig, "customWebsiteUploaded"> | null | undefined,
): boolean {
  return pages.length > 0 || metaPage?.customWebsiteUploaded === true;
}
